import React from 'react'
import './LightBox.css'
import CloseIcon from '@mui/icons-material/Close';
import { useEffect } from 'react';

const LightBox = ({modal, setModal, CurrentDetails, data}) => {
  const modalTop = document.getElementById('content');

  useEffect(() => {
  if(modal === true) {
    if(modalTop.getBoundingClientRect().y <= 10) {
      console.log("modalTop.offsetTop: " + modalTop.getBoundingClientRect().y)
      console.log("window.scrollY: " + window.scrollY)
      window.scrollTo({top:Math.abs(modalTop.getBoundingClientRect().y + window.scrollY), left:0, behavior:"smooth"})
    }
  }

  }, [modal, modalTop])

    function Close( ) {
      setModal(!modal)
    }

  return (
    <>
        
        <div id = "modalContainer" className={modal? 'modalOpen' : 'modalClose' } onClick={Close}>
          <div className="modalOuter">
{data[CurrentDetails].project_url === null ? <a href={'#'}>Project Coming Soon</a> : <a href={data[CurrentDetails].project_url}>{data[CurrentDetails].Header}</a> }
            <div id="content" className="modalContent">
                {
                  CurrentDetails ? <img className="modalImage" src={data[CurrentDetails].src} alt="img" /> : <> Error could not load image</>
                }

              </div>
          </div>


        </div>

    </>
  )
}

export default LightBox